<template>
	<div class="vue-form">
		<b-jumbotron :header="intro.title" :lead="intro.subtitle" header-level="5">
			<span v-html="intro.desc"></span>
		</b-jumbotron>

		<form ref="form" :action="results.action"	method="post" @submit="onSubmit" name="vfm">
			<input type="hidden" name="post" :value="results.post" />

			<div class="email_field_group">
				<input type="hidden" :name="'email_1_from_name'" :value="results.emails[0].from_name"/>
				<input type="hidden" :name="'email_1_from'" :value="results.emails[0].from" />
				<input type="hidden" :name="'email_1_to'" :value="results.emails[0].to" />
				<input type="hidden" :name="'email_1_subject'" :value="results.emails[0].subject" />
				<input type="hidden" :name="'email_1_body'" :value="email_1_body" />
			</div>

			<div class="email_field_group">
				<input type="hidden" :name="'email_2_from_name'" :value="results.emails[1].from_name" />
				<input type="hidden" :name="'email_2_from'" :value="results.emails[1].from" />
				<input type="hidden" :name="'email_2_to'" :value="items.vfm_email.data" />
				<input type="hidden" :name="'email_2_subject'" :value="results.emails[1].subject" />
				<input type="hidden" :name="'email_2_body'" :value="email_2_body" />
			</div>

			<div class="csv_field_group" v-for="(csv, f_index) in this.csv_files">
				<input
					type="hidden"
					:name="'csv_' + (f_index + 1).toString() + '_file'"
					:value="'/upload/results/' + csv.path + csv.file"
				/>
				<input
					v-for="(item, key, i_index) in items"
					:key="key"
					:name="csvEnum(item.name, f_index, i_index)"
					type="hidden"
					:value="getCSVValue(csv.omit, key)"
				/>
				<input name="csv_1_field_15" type="hidden" value="Nights" />
				<input name="csv_1_field_16" type="hidden" value="PerNight" />
				<input name="csv_1_field_17" type="hidden" value="TotalDue" />
				<input name="csv_1_field_18" type="hidden" value="Stamp" />
			</div>
			
			<input type="hidden" name="Nights" :value="this.nightcount" />
			<input type="hidden" name="PerNight" :value="this.nightcost.toFixed(2)" />
			<input type="hidden" name="TotalDue" :value="this.totaldue.toFixed(2)" />
			<input type="hidden" name="Enroll" :value="results.enroll" />
			<input type="hidden" name="Stamp" :value="results.stamp" />
			<input type="hidden" name="confirm" :value="results.confirm" />
			<input type="hidden" name="confirm_template" :value="confirm_template" />
			<div class="miners">
				<input class="miners" name="miners" value />
			</div>

			<b-modal v-model="meta.closed"></b-modal>

			<div class="vfm_item" v-for="(item, key) in items">
				<div v-if="item.section_header">
					<b-card
						bg-variant="light"
						border-variant="default"
						header=" "
						footer=" "
						:title="item.section_header"
						style="margin: 2rem 0"
					>
						<b-card-text v-if="item.section_desc">
							{{ item.section_desc }}
						</b-card-text>
					</b-card>
				</div>

				<span v-if="item.type === 'nodata'">
					<b-card
						v-if="item.style && item.style === 'card'"
						border-variant="secondary"
						bg-variant="light"
						:header="item.title"
						header-text-variant="white"
						header-bg-variant="secondary"
					>
						<p class="card-text">{{ item.label }}</p>
					</b-card>
					<div v-else-if="item.style && item.style === 'html'">
						<span v-html="item.label" style="font-size: .8rem"></span>
					</div>
					<h4 v-else>
						<hr v-if="!item.first" />
						<span v-html="item.label"></span>
					</h4>
				</span>

				<b-form-group
					v-else-if="item.type === 'radio'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-radio-group
						stacked
						v-model="item.data"
						v-on:input="radioTrig(key, item.ctrl, item.data)"
						:name="item.name"
						:options="item.init.options"
					></b-form-radio-group>

					<input
						hidden
						type="radio"
						:name="item.name"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					/>

					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'select'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-select
						v-model="item.data"
						:id="item.name"
						:name="item.name"
						:options="vfm_init(key)"
						v-validate="item.reqs"
						data-vv-validate-on="change"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-select>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'checkbox'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-checkbox-group
						v-model="item.data"
						:id="item.id"
						size="sm"
						:name="item.name"
						:options="item.init.options"
						v-validate="item.reqs"
					></b-form-checkbox-group>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'textarea'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-textarea
						v-model="item.data"
						:name="item.name"
						:placeholder="item.init.placeholder"
						:rows="5"
						:max-rows="10"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-textarea>
					<span v-if="item.reveal">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.reveal && !items[item.reveal.target].show"
							v-on:click="clickReveal(item)"
							>{{ item.reveal.text }}</b-btn
						>
					</span>
					<span v-if="item.hide && item.reveal">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.hide && !items[item.reveal.target].show"
							v-on:click="clickHide(item)"
							>{{ item.hide.text }}</b-btn
						>
					</span>
					<span v-if="item.hide && typeof item.reveal === 'undefined'">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.hide"
							v-on:click="clickHide(item)"
							>{{ item.hide.text }}</b-btn
						>
					</span>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'link'"
					v-show="item.show"
					:description="item.help"
				>
					<span v-html="item.label"></span>
				</b-form-group>
				<b-form-group
					v-else-if="item.name.includes('Phone')"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-input
						:type="item.type"
						:name="item.name"
						:id="item.name"
						v-model="item.data"
						v-bind:formatter="phoneFormatter"
						maxlength="10"
						:placeholder="vfm_init(key)"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-input>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-input
						:type="item.type"
						:name="item.name"
						:id="item.name"
						v-model="item.data"
						:placeholder="vfm_init(key)"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-input>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>
			</div>
			
			<b-alert variant="danger" :show="dateError">Ending Date needs to occur after Beginning Date.</b-alert>
			
			<b-alert show variant="success">Total number of nights: <strong>{{ nightcount }}</strong> x ${{ nightcost.toFixed(2) }} = <strong>${{ totaldue.toFixed(2) }}</strong> <span v-if="nightcount >= 15">(maximum) </span>to be charged.</b-alert>
			<hr>			
			<b-card bg-variant="light" text-variant="dark">
				<h5 v-if="policy.title">{{ policy.title }}</h5>
				<span v-html="policy.desc" style="font-size: .8em;" ></span>
			</b-card>
			<hr />
			<b-card
				show
				bg-variant="light"
				id="terms-gp"
				name="terms-gp"
				v-if="terms.show"
			>
				<h5 v-if="terms.title">{{ terms.title }}</h5>
				<p class="help-text" v-if="terms.text">{{ terms.text }}</p>
				<hr v-if="terms.text" />
				<b-form-checkbox
					id="terms-cb"
					name="terms-cb"
					v-model="terms.data"
					value="accepted"
					unchecked-value
					v-validate.initial="'required'"
					><p v-html="terms.desc"></p>
				</b-form-checkbox>
			</b-card>
			<hr />
			<b-button :disabled="errors.any()" size="lg" type="submit" variant="dark"
				>Submit</b-button>
			<p v-show="errors.any()" style="font-size:.8rem; color: #999999; line-height: 3em">Button disabled. Some required fields are missing.</p> 
		</form>

		<div id="debug" class="debug" v-show="meta.datadebug">
			<h2>Debug</h2>
			<div>
				Errors = {{ errors.any() }}
				<br />
				{{ errors.all() }}
			</div>
			<ul v-for="item in items">
				<span v-if="item.type !== 'nodata'">
					<li>
						<div>
							{{ item.name }}:
							<span class="data-debug">{{ item.data }}</span>
						</div>
						<div v-if="item.ctrl">{{ item.ctrl }}</div>
					</li>
				</span>
			</ul>
			<ul>
				<li>Nights: {{ nightcount }}</li>
			</ul>
			<ul>
				<li>Per Night: ${{ nightcost.toFixed(2) }}</li>
			</ul>
			<ul>
				<li>Total: ${{ totaldue.toFixed(2) }}</li>
			</ul>
			<div v-for="csv in csvPath_a">{{ csv.path }}</div>
			<div>{{ results.confirm }}</div>
		</div>
		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Confirm Template:</h3>
			<hr style="border-bottom: dashed 1px" />
		</div>
		<div id="confirm_template" v-show="meta.templatedebug">
			<b-row>
				<b-col>
					<h5><span v-html="confirm.title"></span></h5>
					<span v-html="confirm.header"></span>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<h5>Submission Details:</h5>
				</b-col>
			</b-row>
			<span v-for="item in items" :key="item.name">
			<b-row v-if="item.style != 'html' && item.show">
				<b-col cols="6">
					<strong v-if="item.type=='nodata'">{{ item.label }}</strong>
					<span v-else>{{ item.label }}</span>
				</b-col>
				<b-col cols="6">{{ item.data }}</b-col>
			</b-row>
			</span>
			<b-row>
				<b-col cols="6">Nights</b-col>
				<b-col cols="6">{{ nightcount }}</b-col>
			</b-row>
			<b-row>
				<b-col cols="6">Per Night</b-col>
				<b-col cols="6">${{ nightcost.toFixed(2) }}</b-col>
			</b-row>
			<b-row>
				<b-col cols="6">Total to be charged</b-col>
				<b-col cols="6">${{ totaldue.toFixed(2) }}</b-col>
			</b-row>
			<b-row>
				<b-col>
					<span style="font-size: .8em">
					<hr>
					<h5><span v-html="policy.title"></span></h5>
					<span v-html="policy.desc"></span>
					
					<hr style="border-bottom: solid 1px gray"/>
					
					<h5><span v-html="terms.title"></span></h5>
					<span v-html="terms.desc"></span>
					
					<hr style="border-bottom: solid 1px gray"/>
					
					<span v-html="confirm.footer"></span>
					</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<div class="mx-auto text-center w-75">
						<p style="font-size:0.7em; font-weight:bold">South Dakota School of Mines and Technology does not discriminate on the basis of race, color, national origin, military status, sex, religion, age, sexual orientation, political preference or disability in employment or the provision of service.</p>
					</div>
					
				</b-col>
			</b-row>
		</div>

		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Email Template 1:</h3>
			<h6>To: {{ results.emails[0].to }}</h6>
			<hr style="border-bottom: dashed 1px" />
		</div>
		<div id="email_template_1" v-show="meta.templatedebug">
			<div style>
				<table
					style="border-collapse: collapse; font: Arial normal 10pt ;"
					cellpadding="3"
				>
					<tr>
						<td colspan="4">
							<p>
								This is an automated message to let you know that you have a new
								submission of the
								<em>{{ meta.form_name }} Application</em> located at
								<a
									:href="
										'https://interact.sdsmt.edu/' +
											meta.root +
											'/' +
											meta.sub +
											'/'
									"
									>https://interact.sdsmt.edu/{{ meta.root }}/{{ meta.sub }}/</a
								>.
							</p>

							<p>
								The link to the submission results file for this form is
								<a
									:href="
										'https://sdmines.sdsmt.edu/upload/results/' +
											results.csv_files[0].path +
											results.csv_files[0].file
									"
								>
									https://sdmines.sdsmt.edu/upload/results/{{
										results.csv_files[0].path
									}}{{ results.csv_files[0].file }} </a
								>.</p>
								<p><strong>Remember</strong>, this file may contain personally identifiable
								information from previous submissions, so <strong>please do not share
								this link.</strong>
							</p>

							<p>
								If you have any trouble accessing the data you've received from
								this submission, please contact
								<a href="mailto:jason.ward@sdsmt.edu">ITS</a>.
							</p>
						</td>
					</tr>
				</table>

				<hr />
				<h4>Submission Information</h4>
				<hr />
				<table
					style="width:100%; border-collapse:collapse;"
					cellpadding="3"
				>
					<div v-for="item in items" :key="item.name">
						<tr v-if="item.style != 'html' && item.show">
							<td style="vertical-align:top">
								<b>{{ item.label }}: </b>
								<!-- <span v-else>{{ item.label }}</span> -->
							</td>
							<td style="vertical-align:top">{{ item.data }}</td>
						</tr>
					</div>
					<div>
						<tr>
							<td style="vertical-align:top"><b>Nights: </b></td>
							<td style="vertical-align:top">{{ nightcount }}</td>
						</tr>
					</div>
					<div>
						<tr>
							<td style="vertical-align:top"><b>Per Night: </b></td>
							<td style="vertical-align:top">${{ nightcost.toFixed(2) }}</td>
						</tr>
					</div>
					<div>
						<tr>
							<td style="vertical-align:top"><b>Total:</b></td>
							<td style="vertical-align:top">${{ totaldue.toFixed(2) }}</td>
						</tr>
					</div>
				</table>
			</div>
		</div>

		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Email Template 2:</h3>
			<h6>To: {{ results.emails[1].to }}</h6>
			<hr style="border-bottom: dashed 1px" />
		</div>
		
		<div id="email_template_2" v-show="meta.templatedebug">
			<div style>
				<table
					style="border-collapse: collapse; font: Arial normal 10pt ;"
					cellpadding="3"
				>
					<tr>
						<td colspan="4">
							<h5><span v-html="confirm.title"></span></h5>
							<span v-html="confirm.header"></span>
						</td>
					</tr>
				</table>
				
				<h4>Submission Information</h4>

				<table
					style="width:100%; border-collapse:collapse;"
					cellpadding="3"	>
					<div v-for="item in items" :key="item.name">
						<tr v-if="item.style != 'html' && item.show">
							<td style="vertical-align:top">
								<b>{{ item.label }}: </b>
								<!-- <span v-else>{{ item.label }}</span> -->
							</td>
							<td style="vertical-align:top">{{ item.data }}</td>
						</tr>
						<tr v-if="item.data === 'Department Contact'">
							<td style="vertical-align:top"><b>*Department Contact: </b></td> 
							<td style="vertical-align:top"><hr style="border-bottom: 1px solid black"/></td>
						</tr>
					</div>
					<div>
						<tr>
							<td style="vertical-align:top"><b>Nights: </b></td>
							<td style="vertical-align:top">{{ nightcount }}</td>
						</tr>
					</div>
					<div>
						<tr>
							<td style="vertical-align:top"><b>Per Night: </b></td>
							<td style="vertical-align:top">${{ nightcost.toFixed(2) }}</td>
						</tr>
					</div>
					<div>
						<tr>
							<td style="vertical-align:top"><b>Total </b></td>
							<td style="vertical-align:top">${{ totaldue.toFixed(2) }}</td>
						</tr>
					</div>
					<tr>
						<td colspan="4">
							<hr>
							<span v-html="policy.title" style="font-weight: bold; margin-top: 1em;"></span>
							<span v-html="policy.desc"></span>
					
							<hr style="border-bottom: solid 1px gray"/>
					
							<span v-html="terms.title" style="font-weight: bold; margin-top: 1em;"></span>
							<span v-html="terms.desc"></span>					
							<hr style="border-bottom: solid 1px gray"/>
					
							<span v-html="confirm.footer"></span>
							
						</td>
					</tr>
					<tr>
						<td colspan="4">
							<p>
								<em>This is an automated response.</em>
							</p>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import {  dates, meta, intro, results, path_hash, terms, items, policy, confirm } from "vfm/form-specs";

var timestamp = require("time-stamp");

export default {
	name: "VueForm",
	computed: {
		csvPath_a: function() {
			var a = [];
			for (var i = 0; i < this.results.csv_files.length; i++) {
				a[i] = {
					path: this.csvPath(i),
					omit: this.results.csv_files[i].omit
				};
			}
			return a;
		},
		
    dateError: function() {
			let startIndex = this.items.vfm_startdate.data ? this.dates.indexOf(this.items.vfm_startdate.data) : 0;
			let endIndex =   this.items.vfm_enddate.data ? this.dates.indexOf(this.items.vfm_enddate.data) : 0;
			if (endIndex > 0) return (endIndex - startIndex) > 0 ? false : true
			else return false
		},
			
		nightcount: function () {
			let startIndex = this.items.vfm_startdate.data ? this.dates.indexOf(this.items.vfm_startdate.data) : 0;
			let endIndex =   this.items.vfm_enddate.data ? this.dates.indexOf(this.items.vfm_enddate.data) : 0;
			let nights = endIndex - startIndex
			return nights >= 15 ? 15 : nights;
		},

// if these change they need to be updated in form-specs.js (const dorms and vfm-rates)		
		nightcost: function() {
			if (this.items.vfm_residencehall.data == 'Connolly') {
				return this.items.vfm_nightcost.data = 21.57
				}
			else if (this.items.vfm_residencehall.data == 'Palmerton') {
				return this.items.vfm_nightcost.data = 21.57
				}
			else if (this.items.vfm_residencehall.data == 'Peterson') {
				return this.items.vfm_nightcost.data = 21.57
				}
				else if (this.items.vfm_residencehall.data == 'Placer') {
				return this.items.vfm_nightcost.data = 26.86
				}
			else if (this.items.vfm_residencehall.data == 'Rocker I') {
				return this.items.vfm_nightcost.data = 33.86
				}
			else if (this.items.vfm_residencehall.data == 'Rocker II') {
				return this.items.vfm_nightcost.data = 33.86
				}
				else {
				return this.items.vfm_nightcost.data = 0.00
				}
    },


    totaldue: function () {
      let tot = this.nightcount * this.nightcost;
      return tot >= 550 ? 550 : tot
    },


		vfm_combined_name: function() {
			var s = "";
			for (var i = 0; i < this.hiddens.email_from_name.length; i++) {
				if (i !== 0) {
					s += " ";
				}
				if (
					typeof this.items[this.hiddens.email_from_name[i]] !== "undefined"
				) {
					s += this.items[this.hiddens.email_from_name[i]];
				} else s += this.hiddens.email_from_name[i];
			}
			return s;
		}
	},

	data() {
		return {
			dates: dates,
			meta: meta,
			results: results,
			items: items,
			intro: intro,
			path_hash: path_hash,
			terms: terms,
			email_1_body: "",
			email_2_body: "",
			confirm_template: "",
			confirm: confirm,
			csv_files: results.csv_files,
			policy: policy,
		};
	},

	methods: {
		stampNow() {
			return timestamp("YYYY/MM/DD-HH:mm:ss");
		},

		onSubmit(evt) {
			evt.preventDefault();
			this.email_1_body = document.getElementById("email_template_1").innerHTML;
			this.email_2_body = document.getElementById("email_template_2").innerHTML;
			this.confirm_template = document.getElementById(
				"confirm_template"
			).innerHTML;
			results.stamp = this.stampNow();
			this.$validator.validateAll().then(result => {
				if (result) {
					if (this.results.miners !== "") {
						results.action = "https://interact.sdsmt.edu/not-authorized.asp";
					} else {
						// update
						results.action =
							"https://sdmines.sdsmt.edu/cgi-bin/global/send_message_2.cgi";
					}
					this.$nextTick(() => {
						this.$refs.form.submit();
					});
				} else {
					alert("Oops. Please fill in the required fields.");
				}
			});
		},

		getCSVValue(omit, key) {
			if (omit.indexOf(key) === -1) {
				return items[key].name;
			} else return " - ";
		},

		vfm_init(key) {
			var item = items[key];
			switch (item.type) {
				case "select":
					if (item.data === "") {
						item.data = null;
					}
					var ph = item.init.placeholder
						? item.init.placeholder
						: "Choose an option";
					var top = [
						{
							text: ph,
							value: null
						}
					];

					if (typeof item.ctrl !== "undefined") {
						if (typeof item.ctrl.from !== "undefined") {
							var key = items[item.ctrl.from];
							var opts = item.init.options[key.data];
							if (typeof opts !== "undefined") {
								if (opts.indexOf(item.data) === -1) {
									item.data = null;
								}
								var opts_oa = [];
								for (var i = 0; i < opts.length; i++) {
									opts_oa[i] = {
										text: opts[i],
										value: opts[i]
									};
								}
								return top.concat(opts_oa);
							}

							top[0].text = item.ctrl.msg
								? item.ctrl.msg
								: "Options depend on another field...";
							return top;
						}
					}
					return top.concat(item.init.options);
				default:
					return item.init.placeholder
						? item.init.placeholder
						: ["Enter response here."];
			}
		},

		csvEnum(name, f_index, i_index) {
			return (
				"csv_" + (f_index + 1).toString() + "_field_" + (i_index + 1).toString()
			);
		},

		stampEnum(f_index) {
			var max = Object.keys(items).length;
			return (
				"csv_" + (f_index + 1).toString() + "_field_" + (max + 1).toString()
			);
		},

		csvPath(f_index) {
			var s = "/upload/results/";
			var ref = this.results.csv_files[f_index].file;
			var path = s + this.results.csv_files[f_index].path;
			// if there's a field with the same name as ref, use its data to build the filename
			if (typeof this.items[ref] !== "undefined") {
				var key = this.items[ref].data;
				if (key !== null && key !== "") {
					var code = this.path_hash[key];
					if (typeof code !== "undefined") {
						return path + key + "-" + code + ".csv";
					} else console.log("Code not found for hashed value.");
				}
				return path + key + ".csv";
			}
			//else csv_filed[i].file is just a filename string
			return path + ref;
		},

		radioTrig(key, ctrl, data) {
			var r = "";
			if (typeof ctrl !== "undefined") {
				for (var j = 0; j < ctrl.length; j++) {
					if (ctrl[j].opener.value === data) {
						for (var i = 0; i < ctrl[j].targets.length; i++) {
							this.items[ctrl[j].targets[i]].show = true;
							r = this.items[ctrl[j].targets[i]].reqs;
							// r += '|required';
							r = "".concat("required|", r);
							this.items[ctrl[j].targets[i]].reqs = r;
						}
					} else {
						for (var i = 0; i < ctrl[j].targets.length; i++) {
							this.items[ctrl[j].targets[i]].show = false;
							this.items[ctrl[j].targets[i]].data = "";
							r = this.items[ctrl[j].targets[i]].reqs;
							if (r.slice(0, 9) === "required|") {
								r = r.slice(9);
							}
							// if (r.slice(-9) === '|required') {
							//   r = r.slice(0, (r.length - 9));
							// }
							this.items[ctrl[j].targets[i]].reqs = r;
						}
					}
				}
			}
		}, // end radioTrig

		phoneFormatter(value){
			if(value.length == 10){
				var str1 = value.substr(0,3);
				var str2= value.substr(3,3);
				var str3 = value.substr(6,4);
				value = str1+"-"+str2+"-"+str3;
			}
			else if (value.length < 12){
				value = value.replaceAll("-","");
			}
			return value;
		} //end phoneFormatter

	} // end methods
	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h1,
h2 {
	// font-weight: bold; 
} */

hr{
	padding-top: 1.1em;
	border: 0;
}

ul {
	padding: 0;
}

li {
	display: inline-block;
	margin: .8em;
}

div.is-danger {
	margin-top: 0.2rem;
	color: #b3a369;
	font-size: 0.8rem;
}

input.is-danger,
select.is-danger {
	border: solid #b3a369 1px;
}

.card-body p {
	font-size: 0.8rem;
}

.debug {
	font-size: 0.7em;
	max-width: 30%;
	height: 100%;
	overflow-y: scroll;
	position: fixed;
	border-right: solid 8px #b3a369;
	padding: 1em;
	right: 0;
	top: 0;
	background: rgba(7, 29, 73, 0.6);
	color: white;
	text-align: left;
}

.help-text {
	font-size: 0.8em;
	font-style: oblique;
	color: #666;
}

.data-debug {
	color: #999;
	font-style: oblique;
}

.jumbotron {
	/* background-color: #071d49;
  color: #fff;  */
	margin-bottom: 30px;
	font-size: 0.9rem;
	color: #071d49;
}

.miners {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/VueForm.vue